<script lang='ts'>
	const props = $props();
</script>
<div class=tab-list>
	{@render props.children()}
</div>

<style>
	.tab-list {
		display: flex;
		flex-direction: row;
		justify-content: center;
		text-align: center;
	}
</style>